import { useContext } from 'react';
import { MultiPortfolioReviewContext } from '../components/common/MultiPortfolioReviewContext';
import { recalculateAssets } from '../review/helpers';
import { useUploadProFormaPortfolioAllocator } from '../useUniversalUploaderAllocator';
import { getRowId, useSharedMultiPortfolioRightPaneContent } from './useSharedMultiPortfolioRightPaneContent';

export const useMultiProFormaRightPaneContent = () => {
  const {
    data: { parsedResults, selectedIndex, strategyData },
  } = useContext(MultiPortfolioReviewContext);
  const excludedInvestments = parsedResults[selectedIndex]!.excludedInvestments;
  const portfolio = recalculateAssets(parsedResults[selectedIndex]!.parsedPortfolio, excludedInvestments);
  const { accessMode, applyInvestmentRemap, includeInvestment, excludeInvestment, changeInvestmentDesignation } =
    useSharedMultiPortfolioRightPaneContent(portfolio);
  const { rowData, columnDefs, autoGroupColumnDefs, rowClassRules } = useUploadProFormaPortfolioAllocator({
    portfolio,
    excludedInvestments,
    accessMode,
    applyInvestmentRemap,
    includeInvestment,
    excludeInvestment,
    changeInvestmentDesignation,
    strategyData,
  });
  return {
    rowData,
    columnDefs,
    autoGroupColumnDefs,
    rowClassRules,
    getRowId,
  };
};
